export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 47 55" version="1.1" {...props}>
            <defs>
                <linearGradient x1="0%" y1="50%" x2="63.3763218%" y2="50%" id="linearGradient-19">
                    <stop stopColor="#F8F8F8" offset="0%" />
                    <stop stopColor="#1F5EEF" offset="100%" />
                </linearGradient>
            </defs>
            <g id="web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="空调产品详情页" transform="translate(-624.000000, -10147.000000)">
                    <g id="编组-3" transform="translate(434.000000, 10127.000000)">
                        <g id="编组-19" transform="translate(190.109638, 20.000000)">
                            <polygon
                                id="矩形"
                                fill="url(#linearGradient-19)"
                                transform="translate(23.504397, 35.037891) rotate(-90.000000) translate(-23.504397, -35.037891) "
                                points="3.54228808 26.7293863 43.4665061 26.7293863 43.4665061 43.3463957 3.54228808 43.3463957"
                            />
                            <polygon
                                id="矩形备份"
                                fill="#1F5EEF"
                                transform="translate(23.390362, 23.390362) rotate(-405.000000) translate(-23.390362, -23.390362) "
                                points="6.8508785 14.1737707 39.9298461 6.8508785 32.6069539 39.9298461"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
